import { Box } from "@mui/material";
import { useTranslation } from "react-i18next"

const ErrorBoundaryPage = () =>{
    const {t} = useTranslation();
    return (
        <Box sx={{display: "flex", justifyContent: "center", alignItems: "center", height: "100vh"}}>
            <h2>{t("platform.errorBoundaryMessage")}</h2>
        </Box>
    )
}

export default ErrorBoundaryPage